
  var _styles = {
  "city-selector": {
    "display": "flex",
    "flexDirection": "row",
    "width": "10rem",
    "paddingBottom": "0.21333rem"
  },
  "city-selector__scroll": {
    "display": "flex",
    "flexDirection": "row",
    "width": "10rem"
  },
  "city-selector__list": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "paddingLeft": "0.32rem"
  },
  "city-selector__item": {
    "minWidth": "1.92rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "paddingTop": "0.16rem",
    "paddingRight": "0.48rem",
    "paddingBottom": "0.16rem",
    "paddingLeft": "0.48rem",
    "marginRight": "0.16rem",
    "backgroundColor": "rgb(245,245,245)",
    "borderRadius": "0.16rem"
  },
  "city-selector__item--selected": {
    "backgroundColor": "rgb(255,209,0)"
  },
  "city-selector__item--first": {
    "paddingLeft": "0.21333rem",
    "paddingRight": "0.26667rem"
  },
  "city-selector__item-content": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "city-selector__location-icon": {
    "display": "flex",
    "flexDirection": "column",
    "marginRight": "0.10667rem"
  },
  "city-selector__arrow-icon": {
    "display": "flex",
    "flexDirection": "column",
    "marginLeft": "0.10667rem"
  },
  "city-selector__item-text": {
    "fontSize": "0.32rem",
    "color": "rgb(51,51,51)",
    "fontWeight": "400"
  },
  "city-selector__item-text--selected": {
    "fontWeight": "600",
    "color": "rgb(0,0,0)"
  }
};



  module.exports = _styles;
  